<pf-section name="ermittelter-ap" [title]="'sendmail.prepare.step.contact-determined' | i18next">

    @if (isJobcenter()) {
        <!-- Jobcenter -->
        <p>
            @if (dienststelleBekannt()) {
                {{ dienststelle.dienststellenName }}<br>
                {{ dienststelle.strasse }} {{ dienststelle.hausnummer }}<br>
                {{ dienststelle.plz }}  {{ dienststelle.ort }}
            } @else {
                {{'sendmail.prepare.step.contact-auto-fail' | i18next}}
            }
        </p>

        <button class="ba-btn dropdown-toggle" aria-controls="collapse-dienststelle"
                type="button" id="btn-search-jc" [attr.aria-label]="jobcenterSuchenButtonLabel()"
                [attr.aria-expanded]="!isCollapsed" [class.collapsed]="isCollapsed" (click)="getDienststellenSearchResult()">
            {{ jobcenterSuchenButtonLabel() }}
        </button>

        <div #collapseDienststelle class="collapse" [class.show]="!isCollapsed" id="collapse-dienststelle" role="tabpanel">
            <div class="row ba-form-row mt-3">
                <div class="col-12">
                    <pf-typeahead name="jobcenter" [options]="jobcenterOptions" [label]="'sendmail.prepare.step.enter-address' | i18next"
                                  (selected)="setJobcenter($event)"></pf-typeahead>
                </div>
            </div>
        </div>

    } @else {
        <!-- Arbeitsagentur -->
        <p>
            {{ dienststelle.dienststellenName }}
            @if (dienststelleBekannt()) {
                <br>{{ dienststelle.strasse }} {{ dienststelle.hausnummer }}<br>
                {{ dienststelle.plz }}  {{ dienststelle.ort }}
            }
        </p>
    }

</pf-section>


